module.exports = {
    expired_1: "Link expired",
    limit_time: "Limited-time Offer for ",
    participate: "Participate in the review event now to claim your exclusive reward!",
    exclusive: "Exclusive",
    reward: "Reward",
    token: "Tokens",
    vip: "Day VIP",
    after_completing: "After completing the review and screenshot verification, you will receive",
    step_1: "<strong style='color: #000000'>Click the button below</strong> to visit the app store and <strong style='color: #000000'>leave a 5-star review.</strong>",
    step_2: "After completing the review, please <strong style='color: #000000'>take a screenshot</strong> of your review content.",
    step_3: "<strong style='color: #000000'>Upload the screenshot</strong> below and submit your in-app ID to receive your reward.",
    click_to: "1. Click to go to the ",
    upload: "2. Upload Review Screenshot",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "Go to ",
    example: "Screenshot example",
    upload_screenshot: "Upload Screenshot",
    claim: "Claim Reward",
    verification_inprogress: "Thank you for your upload. Your screenshot is being reviewed as quickly as possible. Please be patient.",
    verification_success: "Congratulations! <br/><br/> You have successfully claimed your reward. The reward will be credited to your account <strong>within 24 hours.</strong> Please stay tuned. <br/><br/> If you have any questions, feel free to contact customer support.",
    verification_failed: "The screenshot of the review must meet the following conditions: <br/><br/> <div style='margin-left: 6px'> 1.The rating must be 5 stars and the content should be positive. <br/><br/> 2.The review must be made on the <strong> Apple App Store or Google Play Store. </strong> <br/><br/> 3.The screenshot must fully display the review content, including <strong> the avatar, username, and review text. <strong></div>",
    reupload: "Re-upload"
}